export enum AntiFraudAlertStatus {
    NEW = 'new',
    REVIEWED = 'reviewed',
}